import { Pipe, PipeTransform } from '@angular/core';
import { IClassificationParameters } from 'src/modules/shared/models/interfaces/classification-parameters.interface';

@Pipe({
  name: 'filterExistingRobots'
})
export class FilterExistingRobotsPipe implements PipeTransform {
  transform(robots: IClassificationParameters[], searchTerm: string): IClassificationParameters[] {
    if (!searchTerm) return [];
    const searchTermArray: string[] = searchTerm.split(' ');

    return robots.filter((robot: IClassificationParameters) => {
      const fieldsToSearch: string[] = [robot.name];
      return fieldsToSearch.filter((field) => {
        const isMissing = searchTermArray.some((term) => {
          return !field.toLowerCase().includes(term.toLowerCase());
        });
        return !isMissing;
      }).length;
    });
  }
}
